var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaneRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "planeRight",
    width: 22.208,
    height: 7.537,
    viewBox: "0 0 22.208 7.537",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-122{fill:#082a36}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1567",
    d: "M5.483 8.375h5.1l12.777-4.62s2.049-.884 1.647-1.888-3.294-.161-3.294-.161L4.8 7.652z",
    className: "cls-122",
    transform: "translate(-2.852 -.838)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1568",
    d: "M20.976 2.956S15.754.546 14.75.144a2.808 2.808 0 0 0-2.25.482l4.138 4.1z",
    className: "cls-122",
    transform: "translate(-7.458 -.039)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1569",
    d: "M3.425 11.219l-1.968.643L.01 10.255s-.241-.522.241-.723c.522-.2 1.366.321 1.366.321z",
    className: "cls-122",
    transform: "translate(.05 -5.691)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaneRight);
export default __webpack_public_path__ + "static/media/planeRight.dfc360f717ead8089f66e6ef4ef1ed67.svg";
export { ForwardRef as ReactComponent };